import script from "./SearchableSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchableSelect.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__